// extracted by mini-css-extract-plugin
export default {"main":"card_main__rQWLz","logo":"card_logo__TdwfG","greyWrapper":"card_greyWrapper__bt0tT","lista":"card_lista__e41wY"};